export default __webpack_public_path__ + "static/media/1776.1767ecc8.JPG";